import config from "../config.json"


export function getVectorLayerInfo(id: any, period: any, checkPeriod: boolean = true) {

    let vectorLayer = null
    if (checkPeriod) {
        vectorLayer = config.vectorLayers.filter(function (el) {
            return el.id === id && el.period === period
        });
    } else {
        vectorLayer = config.vectorLayers.filter(function (el) {
            return el.id === id
        });
    }

    if (vectorLayer.length === 0 || vectorLayer === null) {
        console.log("Err: Layer could not be found in config.")
    }
    return vectorLayer
}


export function getRasterLayerInfo(id: any, period: any, checkPeriod: boolean) {
    let rasterLayer = null
    if (checkPeriod) {
        rasterLayer = config.rasterLayers.filter(function (el) {
            return el.id === id && el.period === period
        });

    } else {
        rasterLayer = config.rasterLayers.filter(function (el) {
            return el.id === id
        });
    }
    if (rasterLayer.length === 0) {
        console.log("Err: Layer could not be found in config.")
    }
    return rasterLayer
}


export function getBaseLayerInfo(id: any) {
    let baseLayer = null

    baseLayer = config.baseLayers.filter(function (el) {
        return el.id === id
    });
    if (baseLayer.length === 0) {
        console.log("Err: Layer could not be found in config.")
    }
    return baseLayer
}
